import { Alert } from "@mui/material";
import Cities from "Pages/Cities";
import Companies from "Pages/Companies";
import Competencies from "Pages/Competencies";
import Countries from "Pages/Countries/Countries";
import Departments from "Pages/Departments";
import Jobs from "Pages/Jobs";
import Roles from "Pages/Roles";
import Topics from "Pages/Topics";
import Trainers from "Pages/Trainers";
import Users from "Pages/Users/Users";
import Vendors from "Pages/Vendors/Vendors";
import Venues from "Pages/Venues";
import Workshops from "Pages/Workshops";
import WorkshopDetails from "Pages/Workshops/WorkshopsDetails";
import WorkshopsGroups from "Pages/WorkshopsGroups";
import CompanyDepartments from "Pages/CompanyDepartments";
import ActionLoader from "components/UI/ActionLoader";
import { Resources } from "constants/enums";
import { fetchServices } from "framework/services";
import { Feature } from "models/api";

import { useQuery } from "react-query";
import { Route, Routes, useParams } from "react-router-dom";
import Employees from "Pages/Employees";
import CompanyJobs from "Pages/CompanyJobs";
import { RolesPermission } from "Pages/Roles/Roles-permissions";
import CalendarTraining from "Pages/Calender";
import CompanyJobCompetencies from "Pages/CompanyJobCompetencies";
import Permissions from "Pages/Permissions";
import EmployeeCompetencies from "Pages/EmployeeCompetencies";
import Analytics from "Pages/Analytics";
import AnalyticsVendor from "Pages/Analytics/Analytics-vendor";
import Industries from "Pages/Industries";
import WorkshopInvitationResponse from "Pages/WorkshopInvitation/WorkshopInvitationResponse";
import Profile from "Pages/Profile";
import CompanyProficiencyLevels from "Pages/CompanyProficiencyLevels";
import WorkshopEvaluation from "Pages/WorkshopEvaluations/WorkshopEvaluation";
import WorkshopEvaluationQuestionDimension from "Pages/WorkshopEvaluationQuestionDimensions/WorkshopEvaluationQuestionDimensions";
import WorkshopEvaluationQuestions from "Pages/WorkshopEvaluationQuestions";
import WorkshopEvaluationQuestionOptions from "Pages/WorkshopEvaluationQuestionOptions";
import EmployeeWorkshopEvaluation from "Pages/EmployeeWorkshopEvaluation";
import CompanyTopics from "Pages/CompanyTopics";
import CompanyCompetencies from "Pages/CompanyCompetencies";
import Register from "Pages/Vendors/Register";
import AttendanceForm from "Pages/Trainers/Evoloution2";
import VendorAssessmentDefinition from "Pages/VendorAssessmentDefinition";
import { getUserData } from "helpers";
import { UserRoleName } from "types/auth";
import EmployeeWorkshop from "Pages/Workshops/EmployeeWorkshops";
import EmployeeWorkshopDetails from "Pages/Workshops/EmplyeeWorkshopsDetails/EmplyeeWorkshopsDetails";
import VendorAssessmentQuestion from "Pages/VendorAssessmentQuestions";
import BlockIcon from "@mui/icons-material/Block";
import EmployeesGrades from "Pages/Trainers/employess-grades";
import VendorAssessmentQuestionOptions from "Pages/VendorAssessmentQuestionOptions";
import EmployeeWorkshopAssessment from "Pages/EmployeeWorkshopAssessment";
import { Language } from "@mui/icons-material";
import Languages from "Pages/Languages";
import VendorAssessmentTypes from "Pages/VendorAssessmentTypes";
import EmptyContent from "components/EmptyContent";
import { useTranslation } from "react-i18next";
import TrainerAnalytics from "Pages/Analytics/TrainerAnalytics";
import VendorAnalytics from "Pages/Analytics/VendorAnalytics";
import CompanyVendor from "Pages/CompanyVendors/CompanyVendor";
import HeadRoleWorkShop from "Pages/Workshops/HeadRoleWorkshops";
import EmployeeWorkshopAssessmentDetails from "Pages/EmployeeWorkshopAssessment/EmployeeWorkshopAssessmentDetails";
import Corporates from "Pages/Corporates/Corporates";
import CorporateCompetencies from "Pages/CorporateCompetencies";
import CorporateTopics from "Pages/CorporateTopics";
import CorporateVendors from "Pages/CorporateVendors";
import CompetencyMapping from "Pages/CompetencyMapping";
import WorkshopGroupDetails from "Pages/WorkshopsGroups/WorkshopsGroupDetails";
import CorporateWorkshops from "Pages/Workshops/CorporateWorkshops";
import VendorWorkshops from "Pages/Workshops/VendorWorkshops";
import TrainerWorkshops from "Pages/Workshops/TrainerWorkshops";
import EmployeeWorkshopEvaluationDetails from "Pages/EmployeeWorkshopEvaluation/EmployeeWorkshopEvaluationDetails";
import EvaluationReport from "Pages/Workshops/EvaluationReport";
import WorkshopsPerClient from "Pages/WorkshopsPerClient";
import WorkshopScoreData from "Pages/WorkshopScoreData/WorkshopScoreData";
import WorkshopEvaluationData from "Pages/WorkshopEvaluationData/WorkshopEvaluationData";
import VendorAssessmentWorkshops from "Pages/VendorAssessmentWorkshops/VendorAssessmentWorkshops";
import Parameters from "Pages/Parameters";
import CertifyingBodies from "Pages/CertifyingBodies/CertifyingBodies";

interface Props { }

const Listing: React.FC<Props> = () => {
  let { slug } = useParams<{ slug: string }>();
  const userData = getUserData();
  const { t } = useTranslation()
  const { roleName } = userData;
  const { data, isError, isLoading } = useQuery<Feature[]>(
    "features",
    fetchServices
  );
  if (isLoading) return <ActionLoader position="fixed" />;
  if (isError)
    return (
      <Alert severity="error">
        Something went wrong, please try again later.
      </Alert>
    );
  let feature: Feature | undefined = data?.find(
    (feature) =>
      feature.slug === slug ||
      feature.children.some((child) => child.slug === slug)
  );
  if (feature?.children?.length! > 0)
    feature = feature?.children.find((child) => child.slug === slug);
  if (!feature) return <Alert severity="error">404 - Page not found</Alert>;

  // const renderCreateForm = () => {
  //   if (!feature) return null;
  //   if (feature.slug.toLowerCase() === Resources.CATEGORIES)
  //     return <NewCategory feature={feature} />;

  //  };


  const renderWorkshopComponent = (roleName: UserRoleName) => {
    if (!feature) return null;
    switch (roleName) {
      case UserRoleName.EMPLOYEE:
        return <EmployeeWorkshop feature={feature} />;
      case UserRoleName.HEAD_OF_DEPARTMENT:
        return <HeadRoleWorkShop feature={feature} />;
      case UserRoleName.CORPORATE_ADMIN:
        return <CorporateWorkshops feature={feature} />;
      case UserRoleName.VENDOR_ADMIN:
        return <VendorWorkshops feature={feature} />;
      case UserRoleName.TRAINER:
        return <TrainerWorkshops feature={feature} />;
      default:
        return <Workshops feature={feature} />;
    }
  };

  const renderEditForm = () => {
    if (!feature) return null;

    if (feature.slug === Resources.WORKSHOPS_GROUPS)
      return <WorkshopGroupDetails feature={feature} />;
    if (feature.slug === Resources.WORKSHOPS)
      return roleName === UserRoleName.EMPLOYEE ? <EmployeeWorkshopDetails feature={feature} /> : <WorkshopDetails feature={feature} />
    if (feature.slug === Resources.ROLES)
      return <RolesPermission feature={feature} />;
    if (feature.slug === Resources.COMPANY_JOB_COMPETENCY)
      return <CompanyJobCompetencies feature={feature} />;
    if (feature.slug === Resources.TRAINEES_EVALUATION)
      return <AttendanceForm feature={feature} />;
    if (feature.slug === Resources.TRAINEES_GRADES)
      return <EmployeesGrades feature={feature} />;
    if (feature.slug === Resources.EMPLOYEE_COMPETENCY)
      return <EmployeeCompetencies feature={feature} />;
    if (feature.slug === Resources.WORKSHOP_INVITATION_RESPONSE)
      return <WorkshopInvitationResponse feature={feature} />;
    if (feature.slug === Resources.WORKSHOP_EVALUATION_QUESTION)
      return <WorkshopEvaluationQuestions feature={feature} />;
    if (feature.slug === Resources.WORKSHOP_EVALUATION_QUESTION_OPTION)
      return <WorkshopEvaluationQuestionOptions feature={feature} />;
    if (feature.slug === Resources.EMPLOYEE_WORKSHOP_EVALUATION)
      return <EmployeeWorkshopEvaluation feature={feature} />;
    if (feature.slug === Resources.VENDOR_ASSESSMENT_QUESTION)
      return <VendorAssessmentQuestion feature={feature} />;
    if (feature.slug === Resources.VENDOR_ASSESSMENT_QUESTION_OPTION)
      return <VendorAssessmentQuestionOptions feature={feature} />;
    if (feature.slug === Resources.EMPLOYEE_WORKSHOP_ASSESSMENT)
      return <EmployeeWorkshopAssessment feature={feature} />;
    if (feature.slug === Resources.EMPLOYEE_WORKSHOP_ASSESSMENT_DETAILS)
      return <EmployeeWorkshopAssessmentDetails feature={feature} />;
    if (feature.slug === Resources.EMPLOYEE_WORKSHOP_EVALUATION_DETAILS)
      return <EmployeeWorkshopEvaluationDetails feature={feature} />;
    if (feature.slug === Resources.COMPETENCY_MAPPING)
      return <CompetencyMapping feature={feature} />;
    if (feature.slug === Resources.EVALUATION_REPORT)
      return <EvaluationReport feature={feature} />;
    if (feature.slug === Resources.WORKSHOP_SCORE_DATA)
      return <WorkshopScoreData feature={feature} />;
    if (feature.slug === Resources.WORKSHOP_EVALUATION_DATA)
      return <WorkshopEvaluationData feature={feature} />;
    if (feature.slug === Resources.VENDOR_ASSESSMENT_WORKSHOPS)
      return <VendorAssessmentWorkshops feature={feature} />;
    
  };

  const renderList = () => {
    if (!feature) return null;
    if (feature.slug === Resources.PROFILE)
      return <Profile feature={feature} />;
    if (feature.slug === Resources.COUNTRIES)
      return <Countries feature={feature} />;
    if (feature.slug === Resources.DASHBOARD)
      return roleName === UserRoleName.COMPANY_ADMIN ? <Analytics feature={feature} /> : roleName === UserRoleName.TRAINER ? <TrainerAnalytics feature={feature} /> : roleName === UserRoleName.VENDOR_ADMIN ? <VendorAnalytics feature={feature} /> : <EmptyContent
        icon={<BlockIcon sx={{ fontSize: "3.5rem " }} />}
        header={t("T_no_permissions")}
        message={t("T_no_permissions_message")}
      />;
    if (feature.slug === Resources.DASHBOARD_VENDOR)
      return roleName === UserRoleName.COMPANY_ADMIN ? <AnalyticsVendor feature={feature} /> : <EmptyContent
        icon={<BlockIcon sx={{ fontSize: "3.5rem " }} />}
        header={t("T_no_permissions")}
        message={t("T_no_permissions_message")}
      />;
    if (feature.slug === Resources.CITIES) return <Cities feature={feature} />;
    if (feature.slug === Resources.CALENDER)
      return <CalendarTraining feature={feature} />;

    if (feature.slug === Resources.VENDORS)
      return <Vendors feature={feature} />;
    if (feature.slug === Resources.COMPANY_TOPICS)
      return <CompanyTopics feature={feature} />;
    if (feature.slug === Resources.COMPANY_COMPETENCIES)
      return <CompanyCompetencies feature={feature} />;
    if (feature.slug === Resources.TRAINERS)
      return <Trainers feature={feature} />;
    if (feature.slug === Resources.VENUES) return <Venues feature={feature} />;
    if (feature.slug === Resources.PERMISSIONS)
      return <Permissions feature={feature} />;
    if (feature.slug === Resources.USERS) return <Users feature={feature} />;
    if (feature.slug === Resources.COMPETENCIES)
      return <Competencies feature={feature} />;

    if (feature.slug === Resources.WORKSHOPS_GROUPS)
      return <WorkshopsGroups feature={feature} />; if (feature.slug === Resources.TOPICS) return <Topics feature={feature} />;
    if (feature.slug === Resources.WORKSHOPS)
      return renderWorkshopComponent(roleName as UserRoleName)

    if (feature.slug === Resources.COMPANIES)
      return <Companies feature={feature} />;
    if (feature.slug === Resources.DEPARTMENTS)
      return <Departments feature={feature} />;
    if (feature.slug === Resources.JOBS) return <Jobs feature={feature} />;
    if (feature.slug === Resources.ROLES) return <Roles feature={feature} />;
    if (feature.slug === Resources.EMPLOYEES)
      return <Employees feature={feature} />;
    if (feature.slug === Resources.COMPANY_DEPARTMENT)
      return <CompanyDepartments feature={feature} />;
    if (feature.slug === Resources.COMPANY_JOB)
      return <CompanyJobs feature={feature} />;
    if (feature.slug === Resources.INDUSTRY)
      return <Industries feature={feature} />;
    if (feature.slug === Resources.WORKSHOP_INVITATION_RESPONSE)
      return <WorkshopInvitationResponse feature={feature} />;
    if (feature.slug === Resources.COMPANY_PROFICIENCY_LEVELS)
      return <CompanyProficiencyLevels feature={feature} />;
    if (feature.slug === Resources.COMPANY_PROFICIENCY_LEVELS)
      return <CompanyProficiencyLevels feature={feature} />;
    if (feature.slug === Resources.WORKSHOP_EVALUATION)
      return <WorkshopEvaluation feature={feature} />;
    // if (feature.slug === Resources.WORKSHOP_EVALUATION_QUESTION)
    //   return <WorkshopEvaluationQuestions feature={feature} />;
    if (feature.slug === Resources.WORKSHOP_EVALUATION_QUESTION_DIMENSION)
      return <WorkshopEvaluationQuestionDimension feature={feature} />;
    if (feature.slug === Resources.WORKSHOP_EVALUATION_QUESTION_OPTION)
      return <WorkshopEvaluationQuestionOptions feature={feature} />;
    if (feature.slug === Resources.VENDOR_ASSESSMENT_QUESTION_OPTION)
      return <VendorAssessmentQuestionOptions feature={feature} />;
    if (feature.slug === Resources.REGISTER)
      return <Register feature={feature} />;
    if (feature.slug === Resources.LANGUAGE)
      return <Languages feature={feature} />;
    if (feature.slug === Resources.VENDOR_ASSESSMENT_TYPE)
      return <VendorAssessmentTypes feature={feature} />;
    if (feature.slug === Resources.VENDOR_ASSESSMENT_DEFINITION)
      return <VendorAssessmentDefinition feature={feature} />;
    if (feature.slug === Resources.COMPANY_VENDOR)
      return <CompanyVendor feature={feature} />;
    if (feature.slug === Resources.CORPORATE)
      return <Corporates feature={feature} />;
    if (feature.slug === Resources.CORPORATE_COMPETENCIES)
      return <CorporateCompetencies feature={feature} />;
    if (feature.slug === Resources.CORPORATE_TOPICS)
      return <CorporateTopics feature={feature} />;
    if (feature.slug === Resources.CORPORATE_VENDOR)
      return <CorporateVendors feature={feature} />;
    if (feature.slug === Resources.WORKSHOPS_PER_CLIENT)
      return <WorkshopsPerClient feature={feature} />;
    if (feature.slug === Resources.PARAMETER)
      return <Parameters feature={feature} />;
    if (feature.slug === Resources.CERTIFYING_BODIES)
      return <CertifyingBodies feature={feature} />;
  };

  return (
    <>
      <Routes>
        <Route path="/*" element={renderList()} />
        {/* <Route path="new" element={renderCreateForm()} /> */}
        <Route path={`:${feature.singleName}Id/*`} element={renderEditForm()} />
      </Routes>
    </>
  );
};

export default Listing;
